<div
  fxLayout="column"
  fxLayoutAlign="space-between"
>
  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <h3
      class="clickable"
      (click)="openTruck()"
    >
      <i class="mdi s24 mr-5 mdi-{{ alert.icon }} {{ alert.iconColor }}"></i>{{ alert.title }}
    </h3>
    @if (ordId) {
      <a
        [routerLink]="['/orders', ordId]"
        [matTooltip]="'order' | translate"
        (click)="close()"
      >
        <i class="mdi s20 secondary-text mdi-open-in-new"></i>
      </a>
    }
  </div>

  <div class="ph-24 pt-10">
    <div>{{ alert.description }}</div>
    <div class="secondary-text">
      {{ 'alertLateSince' | translate }}: {{ alert.created | amsDateTime }}
    </div>
  </div>
</div>
